/**
 * Unified Graft Model payload indices – single source of truth.
 * Matches @graftcode/protocol and graft-model.types.ts / graft-model-with-type-usage.data.ts.
 */

/** LIBRARY: [LIBRARY_GROUP_ID, LIBRARY_NAME, LIBRARY_VERSION, RUNTIME_NAME, GMA_UGM_VERSION, TYPE_DEF, ...] */
export const LIBRARY = {
  GROUPID: 0,
  NAME: 1,
  VERSION: 2,
  TYPEDEFS_FROM: 3,
} as const

/** TYPE_DEF: [NAMESPACE, TYPENAME, MODULE_FULLNAME, MODULE_HASH, MODIFIER, GENERIC_PARAMETERS?, ...members] */
export const TYPE_DEF = {
  NAMESPACE: 0,
  TYPENAME: 1,
  MODULE_FULLNAME: 2,
  MODIFIER: 4,
  MEMBERS_FROM: 5,
} as const

/** METHOD: [NAME, TYPE_USAGE (return), MODIFIER, PARAMETERS_ARRAY] */
export const METHOD = {
  NAME: 0,
  RETURN_TYPE: 1,
  MODIFIER: 2,
  PARAMETERS: 3,
} as const

/** CONSTRUCTOR: [CLASS_NAME, MODIFIER, PARAMETERS_ARRAY] */
export const CONSTRUCTOR = {
  CLASS_NAME: 0,
  MODIFIER: 1,
  PARAMETERS: 2,
} as const

/** FIELD: [NAME, TYPE_USAGE, MODIFIER, CLASS_NAME] */
export const FIELD = {
  NAME: 0,
  TYPE_USAGE: 1,
  MODIFIER: 2,
  DECLARING_TYPE: 3,
} as const

/** PARAMETER: [TYPE_USAGE, NAME] */
export const PARAMETER = {
  TYPE_USAGE: 0,
  NAME: 1,
} as const

/** TYPE_USAGE wraps a single node: payload = [TYPE_USAGE_NODE] */
export const TYPE_USAGE = {
  NODE: 0,
} as const

/**
 * TYPE_USAGE_PRIMITIVE: [IS_NULLABLE, NAMESPACE, TYPENAME, PRIMITIVE_TYPE, ASSEMBLY_NAME, ASSEMBLY_VERSION]
 * PrimitiveType from graft-model.types: 0=GRAFT_MODEL, 1=STRING, 2=INTEGER, 3=BOOLEAN, 4=FLOAT, ...
 */
export const TYPE_USAGE_PRIMITIVE = {
  IS_NULLABLE: 0,
  NAMESPACE: 1,
  TYPENAME: 2,
  PRIMITIVE_TYPE: 3,
} as const

/** TYPE_USAGE_GENERIC_ALIAS: [IS_NULLABLE, ALIAS_NAME] */
export const TYPE_USAGE_GENERIC_ALIAS = {
  IS_NULLABLE: 0,
  ALIAS_NAME: 1,
} as const

/** TYPE_USAGE_ARRAY: [IS_NULLABLE, ARRAY_DIMENSION, ELEMENT_TYPE_USAGE] */
export const TYPE_USAGE_ARRAY = {
  IS_NULLABLE: 0,
  DIMENSION: 1,
  ELEMENT_TYPE: 2,
} as const

/** TYPE_USAGE_GENERIC: [IS_NULLABLE, GENERIC_NAME, ...TYPE_USAGE_NODE[]] */
export const TYPE_USAGE_GENERIC = {
  IS_NULLABLE: 0,
  GENERIC_NAME: 1,
  TYPE_ARGS_FROM: 2,
} as const
